import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../Styles/Order.css";
import RecommendedItem from "../containers/_RecommendedItem";
import locales from "../../../_constants/locales";

var last_recommended_items_scroll_time = new Date().getTime();

class recommendedItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disable_next: true,
            disable_previous: true,
            scroll_to: 0,
            total_number_of_items: 0
        };
    }

    getTotalNumberOfItems() {
        if (document.getElementById("recommended-items-list")) {
            return document.getElementById("recommended-items-list").children.length;
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.processResize.bind(this));
        this.checkButtons();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.scroll_to !== prevState.scroll_to) {
            if (this.state.scroll_to < prevState.scroll_to) {
                this.getElementAtPosition(this.state.scroll_to).scrollIntoView({ inline: "start" });
            } else {
                this.getElementAtPosition(this.state.scroll_to).scrollIntoView({ inline: "end" });
            }
        }
    }

    processResize() {
        this.moveToStart();
        this.checkButtons();
    }

    checkButtons() {
        if (this.getFirstViewedElement() && this.isFirstElement(this.getFirstViewedElement())) {
            this.setState({ disable_previous: true });
        } else {
            this.setState({ disable_previous: false });
        }

        if (this.getLastViewedElement() && this.isLastElement(this.getLastViewedElement())) {
            this.setState({ disable_next: true });
        } else {
            this.setState({ disable_next: false });
        }
    }

    moveToStart() {
        if (this.getElementAtPosition(0)) {
            this.getElementAtPosition(0).scrollIntoView({ behavior: "auto", inline: "start" });
            this.setState({ scroll_to: 0 });
        }
    }

    getIndexOfElement(element) {
        var recommended_item_list_elements = document.getElementById("recommended-items-list").children;

        var array = [];
        for (let i = 0; i < recommended_item_list_elements.length; i++) {
            array[i] = recommended_item_list_elements[i];
        }

        return array.indexOf(element);
    }

    getElementAtPosition(index) {
        if (document.getElementById("recommended-items-list")) {
            return document.getElementById("recommended-items-list").children[index];
        }
    }

    getLastViewedElement() {
        if (document.getElementById("recommended-items-list")) {
            var recommended_item_list_elements = document.getElementById("recommended-items-list").children;

            for (let i = recommended_item_list_elements.length - 1; i > -1; i--) {
                const recommended_item = recommended_item_list_elements[i];

                if (this.isScrolledIntoViewRight(recommended_item)) {
                    return recommended_item;
                }
            }
        }

        return null;
    }

    getFirstViewedElement() {
        if (document.getElementById("recommended-items-list")) {
            var recommended_item_list_elements = document.getElementById("recommended-items-list").children;

            for (let i = 0; i < recommended_item_list_elements.length; i++) {
                const recommended_item = recommended_item_list_elements[i];

                if (this.isScrolledIntoViewLeft(recommended_item)) {
                    return recommended_item;
                }
            }
        }

        return null;
    }

    isFirstElement(element) {
        var recommended_item_list_elements = document.getElementById("recommended-items-list").children;

        var array = [];
        for (let i = 0; i < recommended_item_list_elements.length; i++) {
            array[i] = recommended_item_list_elements[i];
        }

        return array.indexOf(element) === 0;
    }

    isLastElement(element) {
        var recommended_item_list_elements = document.getElementById("recommended-items-list").children;

        var array = [];
        for (let i = 0; i < recommended_item_list_elements.length; i++) {
            array[i] = recommended_item_list_elements[i];
        }

        return array.indexOf(element) === array.length - 1;
    }

    getNextElement() {
        var recommended_item_list_elements = document.getElementById("recommended-items-list").children;

        for (let i = recommended_item_list_elements.length - 1; i > -1; i--) {
            const recommended_item = recommended_item_list_elements[i];

            if (this.isScrolledIntoViewRight(recommended_item) && i < recommended_item_list_elements.length - 1) {
                return recommended_item_list_elements[i + 1];
            }
        }

        return null;
    }

    getPreviousElement() {
        var recommended_item_list_elements = document.getElementById("recommended-items-list").children;

        for (let i = 0; i < recommended_item_list_elements.length; i++) {
            const recommended_item = recommended_item_list_elements[i];

            if (this.isScrolledIntoViewLeft(recommended_item) && i > 0) {
                return recommended_item_list_elements[i - 1];
            }
        }

        return null;
    }

    isScrolledIntoViewRight(element) {
        var recommended_items_list_element = document.getElementById("recommended-items-list");
        var recommended_items_list_element_position = recommended_items_list_element.getBoundingClientRect();

        var list_left = recommended_items_list_element_position.left;
        var list_right = recommended_items_list_element_position.left + recommended_items_list_element_position.width;

        var element_position = element.getBoundingClientRect();
        var element_right = element_position.left + element_position.width - 5;

        return list_left <= element_right && list_right >= element_right;
    }

    isScrolledIntoViewLeft(element) {
        var recommended_items_list_element = document.getElementById("recommended-items-list");
        var recommended_items_list_element_position = recommended_items_list_element.getBoundingClientRect();

        var list_left = recommended_items_list_element_position.left;
        var list_right = recommended_items_list_element_position.left + recommended_items_list_element_position.width;

        var element_position = element.getBoundingClientRect();
        var element_left = element_position.left + 5;

        return list_left <= element_left && list_right >= element_left;
    }

    handleNextClick() {
        if (!this.isScrolling()) {
            var last_viewed_element = this.getLastViewedElement();
            if (last_viewed_element) {
                var next_element = this.getNextElement();
                if (next_element) {
                    this.setState({ scroll_to: this.getIndexOfElement(next_element) });
                }
            }

            this.setState({ disable_previous: false });
        }
    }

    handlePreviousClick() {
        if (!this.isScrolling()) {
            var first_viewed_element = this.getFirstViewedElement();
            if (first_viewed_element) {
                var previous_element = this.getPreviousElement();
                if (previous_element) {
                    this.setState({ scroll_to: this.getIndexOfElement(previous_element) });
                }
            }

            this.setState({ disable_next: false });
        }
    }

    scrolling() {
        last_recommended_items_scroll_time = new Date().getTime();
    }

    isScrolling() {
        return new Date().getTime() < last_recommended_items_scroll_time + 50;
    }

    render() {
        if (
            (this.props.order.related_items && this.props.order.related_items.length > 0) ||
            (this.props.order.recommended_store_items && this.props.order.recommended_store_items.length > 0)
        ) {
            var items = [];
            var items_to_display = [];
            var heading = "";
            var subheading = "";

            if (this.props.order.recommended_store_items.length > 0) {
                items = this.props.order.recommended_store_items;
                heading =
                    locales[this.props.store[0]][this.props.language].ORDER_PAGE.MARKETING.RECOMMENDED_ITEMS.HEADING;
                subheading =
                    locales[this.props.store[0]][this.props.language].ORDER_PAGE.MARKETING.RECOMMENDED_ITEMS
                        .SUB_HEADING;
            } else if (this.props.order.related_items.length > 0) {
                items = this.props.order.related_items;
                heading = locales[this.props.store[0]][this.props.language].ORDER_PAGE.MARKETING.RELATED_ITEMS.HEADING;
                subheading =
                    locales[this.props.store[0]][this.props.language].ORDER_PAGE.MARKETING.RELATED_ITEMS.SUB_HEADING;
            }

            items.forEach((item, i) => {
                items_to_display.push(<RecommendedItem key={i} id={`recommended-item-${i}`} item={item} />);
            });

            return (
                <div className="recommended-items">
                    <div className="divider-2" />
                    <div className="recommended-items-header">
                        <h2 className="recommended-items-heading">{heading}</h2>
                        <p className="recommended-items-subheading">{subheading}</p>
                    </div>
                    <div className="relative">
                        <button
                            disabled={this.isScrolling()}
                            className="navigation-button left"
                            hidden={this.state.scroll_to === 0}
                            onClick={this.handlePreviousClick.bind(this)}
                        >
                            <p className="navigation-button-chevron-left" />
                        </button>

                        <div
                            onScroll={this.scrolling.bind(this)}
                            id="recommended-items-list"
                            className="layout horizontal list"
                        >
                            {items_to_display}
                        </div>

                        <button
                            disabled={this.isScrolling()}
                            className="navigation-button right"
                            hidden={this.state.scroll_to === this.getTotalNumberOfItems() - 1}
                            onClick={this.handleNextClick.bind(this)}
                        >
                            <p className="navigation-button-chevron-right" />
                        </button>
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(recommendedItems);



// WEBPACK FOOTER //
// ./src/views/Order/components/_RecommendedItems.jsx